import React from "react";
import TableTemplate from "../../components/common/TableTemplate";
import { formatValue } from "../../utils/utils";
import Header from "../../components/common/table/Header";
import Cell from "../../components/common/table/Cell";

const PagesPage = () => {
  // Mock data based on the image
  const mockPagesData = [
    {
      id: 1,
      name: "GearPro Shop",
      adLibraryLink: "fb.com/ads/library/12345",
      totalReach: 245678,
      evo1Day: 12000,
      evo3Days: 28000,
      countries: "US, CA, UK",
      pageId: "001",
    },
    {
      id: 2,
      name: "Adventure Gear",
      adLibraryLink: "fb.com/ads/library/23456",
      totalReach: 189432,
      evo1Day: 5000,
      evo3Days: 15000,
      countries: "FR, DE, IT",
      pageId: "002",
    },
    {
      id: 3,
      name: "OutdoorLife",
      adLibraryLink: "fb.com/ads/library/34567",
      totalReach: 326891,
      evo1Day: 8000,
      evo3Days: 22000,
      countries: "AU, NZ",
      pageId: "003",
    },
    {
      id: 4,
      name: "TrekMaster",
      adLibraryLink: "fb.com/ads/library/45678",
      totalReach: 156234,
      evo1Day: 3000,
      evo3Days: 7000,
      countries: "ES, PT",
      pageId: "004",
    },
    {
      id: 5,
      name: "WildGear",
      adLibraryLink: "fb.com/ads/library/56789",
      totalReach: 278543,
      evo1Day: 15000,
      evo3Days: 31000,
      countries: "JP, KR",
      pageId: "005",
    },
  ];

  // Define table columns
  const columns = [
    {
      id: "name",
      accessorKey: "name",
      header: ({ column }) => (
        <Header
          columnInfo={{
            display: "Name",
            key: "name",
            type: "text",
          }}
        />
      ),
      cell: ({ row, getValue }) => (
        <Cell
          info={{
            getValue: () => getValue(),
            row: row,
            table: row.table,
          }}
          columnInfo={{
            key: "name",
            type: "text",
          }}
        />
      ),
      size: 150,
    },
    {
      id: "adLibraryLink",
      accessorKey: "adLibraryLink",
      header: ({ column }) => (
        <Header
          columnInfo={{
            display: "Ad Library Link",
            key: "adLibraryLink",
            type: "text",
          }}
        />
      ),
      cell: ({ row, getValue }) => (
        <div className="text-blue-500 hover:text-blue-700 cursor-pointer truncate">
          <a
            href={`https://${getValue()}`}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            {getValue()}
          </a>
        </div>
      ),
      size: 200,
    },
    {
      id: "totalReach",
      accessorKey: "totalReach",
      header: ({ column }) => (
        <Header
          columnInfo={{
            display: "Total Reach",
            key: "totalReach",
            type: "number",
          }}
        />
      ),
      cell: ({ row, getValue }) => (
        <div className="text-right font-medium">
          {getValue()?.toLocaleString()}
        </div>
      ),
      size: 120,
    },
    {
      id: "evo1Day",
      accessorKey: "evo1Day",
      header: ({ column }) => (
        <Header
          columnInfo={{
            display: "Evo 1 Day",
            key: "evo1Day",
            type: "number",
          }}
        />
      ),
      cell: ({ row, getValue }) => (
        <div className="text-right font-medium">
          {getValue()?.toLocaleString()}
        </div>
      ),
      size: 120,
    },
    {
      id: "evo3Days",
      accessorKey: "evo3Days",
      header: ({ column }) => (
        <Header
          columnInfo={{
            display: "Evo 3 Days",
            key: "evo3Days",
            type: "number",
          }}
        />
      ),
      cell: ({ row, getValue }) => (
        <div className="text-right font-medium">
          {getValue()?.toLocaleString()}
        </div>
      ),
      size: 120,
    },
    {
      id: "countries",
      accessorKey: "countries",
      header: ({ column }) => (
        <Header
          columnInfo={{
            display: "Countries",
            key: "countries",
            type: "text",
          }}
        />
      ),
      cell: ({ row, getValue }) => (
        <div className="text-center">{getValue()}</div>
      ),
      size: 120,
    },
    {
      id: "pageId",
      accessorKey: "pageId",
      header: ({ column }) => (
        <Header
          columnInfo={{
            display: "Page ID",
            key: "pageId",
            type: "text",
          }}
        />
      ),
      cell: ({ row, getValue }) => (
        <div className="text-center font-mono text-sm">{getValue()}</div>
      ),
      size: 100,
    },
  ];

  const tableOptions = {
    enableGlobalFilter: false,
    enablePagination: false,
    enableColumnVisibility: false,
    enableSorting: false,
    enableColumnFilters: false,
    enableRowSelection: false,
    defaultPageSize: 25,
    showTotalItems: false,
    showPreferences: false,
  };

  return (
    <div className="w-full">
      {/* Header */}
      <div className="p-4 rounded-lg ">
        <h1 className="text-2xl font-bold text-gray-800">Pages</h1>
      </div>

      {/* Table Container */}
      <div className="bg-white rounded-lg border-gray-200 shadow-sm w-full">
        <TableTemplate
          columns={columns}
          data={mockPagesData}
          options={tableOptions}
          title="Pages Data"
          containerClassName="w-full"
          tableClassName="w-full min-w-full"
          headerClassName="bg-gray-50"
          rowClassName="hover:bg-gray-50"
          cellClassName="px-4 py-3 border-b border-gray-200"
        />
      </div>
    </div>
  );
};

export default PagesPage;
